<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full">
                <div class="cursor-pointer" :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">CopyrightAmendment Information</div>
                  </div>
                </div>
                <div class="cursor-pointer" :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div class="cursor-pointer" :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightAmendmentApplication v-if="currentRoute === 'forms'" :task="task"/>
              <CopyrightAmendmentFormFiles v-if="currentRoute === 'attachments'" :task="task"/>
              <CopyrightAmendmentMessages v-if="currentRoute === 'messages'" :task="task"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CopyrightAmendmentMessages from "@/views/home/services/copyright-amendment/task/CopyrightAmendmentMessages.vue";
import CopyrightAmendmentFormFiles from "@/views/home/services/copyright-amendment/task/CopyrightAmendmentFormFiles.vue";
import CopyrightAmendmentApplication from "@/views/home/services/copyright-amendment/task/CopyrightAmendmentApplication.vue";
export default {
  name: "CopyrightAmendmentApplicationDetails",
  components: {CopyrightAmendmentApplication, CopyrightAmendmentFormFiles, CopyrightAmendmentMessages},
  props:{
    task:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
